<template>
  <div class="entry-wrapper" @click="$emit('update', this)">
    <div class="entry__headline icon-angle-right-after">
      <h5>{{text}}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntryWrapper',
  props: ['text']
}
</script>
